import { render, staticRenderFns } from "./ValidChip.vue?vue&type=template&id=5f9a950e"
import script from "./ValidChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValidChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports